import { jsx as _jsx } from "react/jsx-runtime";
import { useIsMobileContext } from "../../contexts";
import { LegendWarriorMobileCard } from "./LegendWarriorMobileCard";
import { LegendWarriorDesktopCard } from "./LegendWarriorDesktopCard";
export function WarriorCard(props) {
    var _a = props.data, firstName = _a.firstName, lastName = _a.lastName, key = _a.key, image288x360url = _a.image288x360url, image104x141url = _a.image104x141url, year = _a.year;
    var isMobile = useIsMobileContext();
    return isMobile
        ? _jsx(LegendWarriorMobileCard, { name: firstName + " " + lastName, cardSubText: {
                sl: year.toString(),
                en: year.toString()
            }, imageUrl: image104x141url, to: "/club/history/warriors/".concat(key) })
        : _jsx(LegendWarriorDesktopCard, { name: firstName + " " + lastName, cardSubText: {
                sl: year.toString(),
                en: year.toString()
            }, imageUrl: image288x360url, to: "/club/history/warriors/".concat(key) });
}
